import { fileVars } from 'tools/Files/graphql'
import gql from 'utils/gql'

import { topicListValues } from 'app/libreon/Forums/graphqlVars'

export const projectListValues = `
  id
  shortId
  title
  updatedAt
  insertedAt
  releasedAt
  visibility
  rating
  website
  format
  status
  avatar
  features
`

const projectLoadValues = `
  ${projectListValues}
  subtitle
  license
  summary
  myAccess
  tags {
    id
    tag {
      id
      type
      label
      info
      meta
      group {id label}
    }
  }
  members {
    id
    type
    roles
    user {
      id
      handle
      name
      lastSeen
      avatar
    }
  }
  files {
    ${fileVars}
  }
  data(types: ["profile"]) {
    id
    type
    value
  }
  journeyActor {
    id
    type
    journeyMaps {
      id
      shortId
      milestoneId
      updatedAt
      insertedAt
      journey {
        id
        name
        milestones {
          id
          name
          order
          meta
        }
      }
    }
  }
`

const projectLoadForums = `
forums(id: $forumId, type: $forumType) { id meta type }
`

const projectListForums = `
forums { id meta type }
`

export const LIST_PROJECTS = gql`
  query listProjects($filter: InputProjectFilter!) {
    projects(filter: $filter) {
      success reason total offset matching results {${projectListValues}}
    }
  }
`

export const LOAD_PROJECT = gql`
  query loadProject($id: ShortId!, $forumId: ShortId, $forumType: ForumType) {
    projects(filter: {id: $id}) {
      success reason total matching result {${projectLoadValues}${projectLoadForums}}
    }
  }
`

export const UPSERT_PROJECT = gql`
  mutation changeProject($project: InputProject) {
    changeProject(project: $project) {
      success message result {
        ... on Project { ${projectLoadValues} ${projectListForums} } }
    }
  }
`

export const UPSERT_PROJECT_MEMBER = gql`
  mutation upsertProjectMember($projectId: ShortId!, $member: InputProjectMember!) {
    upsertProjectMember(projectId: $projectId, member: $member) {
      success reason meta result { ${projectLoadValues} ${projectListForums} }
    }
  }
`

export const REACTOR_ACTIVITYS = gql`
  query reactorActivitys($projectId: ShortId) {
    reactorActivitys(projectId: $projectId) {
      id
      name
      explain
      visible
      context
      links {
        id
        order
        activityId
      }
      triggers {
        id
      }
      conditions
      actions
      completed
      journal {
        id
        meta
      }
      meta
    }
  }
`

export const LIST_PROJECT_TOPICS = gql`
  query loadProject($id: ShortId!, $forumId: ShortId, $forumType: ForumType) {
    projects(filter: {id: $id}) {
      success
      reason
      result {
        id forums(id: $forumId, type: $forumType) {
          id type meta topics {
            ${topicListValues}
          }
        }
      }
    }
  }
`
